import React from 'react';
import { motion } from 'framer-motion';
export function HookSection() {
  return <section className="bg-white py-20 px-6" data-id="element-112">
      <div className="max-w-3xl mx-auto" data-id="element-113">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="prose prose-lg md:prose-xl text-navy font-body text-[18px] leading-relaxed" data-id="element-114">
          <p className="mb-6" data-id="element-115">
            Você sabe exatamente para onde foi cada centavo do seu último
            salário?
          </p>
          <p className="mb-6" data-id="element-116">
            A maioria dos profissionais vive com uma ansiedade financeira
            constante porque o dinheiro simplesmente "evapora". Você trabalha
            duro, mas no dia 20 sua conta bancária já está perto de zero.
          </p>
          <p className="mb-6" data-id="element-117">
            Você não precisa de um contador ou fórmulas complexas. Você precisa
            de um{' '}
            <strong className="text-orange font-bold" data-id="element-118">SISTEMA DE ORDEM</strong>.
          </p>
          <p data-id="element-119">
            Um que você possa implementar em uma tarde e que trabalhe por você
            de forma automática o resto do mês.
          </p>
        </motion.div>
      </div>
    </section>;
}